<template>
  <div class="home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <Layout class="layout">
      <Header class="header">
        <Menu mode="horizontal" theme="dark" active-name="1" class="top-bar">
          <div class="layout-logo">
            <img src="./../assets/logo.png" height="42" style="margin-right:10px;" v-show="['xs','sm','md','lg'].indexOf($store.getters.screenSize)>-1">
            <div class="site-name-area" v-show="['sm','md','lg'].indexOf($store.getters.screenSize)>-1">
              <h2 class="inline font-white">{{getConfig('TITLE')}}</h2>
              <div class="small font-grey">{{getConfig('SUBTITLE')}}</div>
            </div>
          </div>
          <div class="layout-nav" v-if="['md','lg'].indexOf($store.getters.screenSize)>-1">
            <MenuItem name="1" to="/guarantees/list">
              <Icon type="md-list-box"></Icon>
              保函管理
            </MenuItem>
            <MenuItem name="2" to="/guarantees/verify">
              <Icon type="md-barcode"></Icon>
              保函查验
            </MenuItem>
            <MenuItem name="3" to="/statistics/overall">
              <Icon type="ios-analytics"></Icon>
              统计中心
            </MenuItem>
            <!-- <MenuItem name="4">
              <Icon type="ios-paper"></Icon>
              业务报表
            </MenuItem> -->
          </div>
          <div class="pull-right" style="margin-right:20px">
            <div class="top-bar-search" :class="{expand:searchFocused}" v-if="['lg'].indexOf($store.getters.screenSize)>-1">
              <Input v-model="searchKeyword" search :placeholder="searchFocused?'搜索保函编号/受益人/保证人':'搜索'" @on-focus="searchFocused=true" @on-blur="searchInputBlur" @on-search="searchFuzzy" />
            </div>
            <template v-if="['xs','sm'].indexOf($store.getters.screenSize)>-1">
              <Tooltip content="保函管理">
                <Button type="text" to="/guarantees/list" ghost icon="md-list-box"></Button>
              </Tooltip>
              <Tooltip content="保函查验">
                <Button type="text" to="/guarantees/verify" ghost icon="md-barcode"></Button>
              </Tooltip>
              <Tooltip content="统计中心">
                <Button type="text" to="/statistics/overall" style="margin-right:16px;" ghost icon="ios-analytics"></Button>
              </Tooltip>
            </template>
            <Tooltip content="搜索" v-if="['xs','sm','md'].indexOf($store.getters.screenSize)>-1">
              <Button type="text" @click="showQuickSearchBox=true" ghost icon="md-search"></Button>
              <div class="quick-search-box" v-show="showQuickSearchBox">
                <Button type="primary" class="quit-icon" size="small" shape="circle" @click="showQuickSearchBox=false" icon="md-close"></Button>
                <div class="top-bar-search expand">
                  <Input v-model="searchKeyword" search placeholder="搜索保函编号/受益人/保证人" @on-blur="searchInputBlur" @on-search="searchFuzzy" />
                </div>
              </div>
            </Tooltip>
            <Tooltip content="我的">
              <Button type="text" to="/dashboard" ghost icon="md-person"></Button>
            </Tooltip>
            <Tooltip content="登出">
              <Button type="text" ghost @click="logOut" icon="md-exit"></Button>
            </Tooltip>
          </div>
        </Menu>
      </Header>
      <Layout :style="{overflow:!isMobile?'hidden':'auto'}">
        <Sider v-if="!isMobile" collapsible class="left-menu" :collapsed-width="78" v-model="isCollapsed" :style="{background: '#fff', overflowY: 'hidden', overflowX: 'hidden', position: 'relative'}" :hide-trigger="true">
          <div class="left-menu-trigger" slot="trigger">
            <Tooltip :content="isCollapsed?'展开':'收起'">
              <Icon @click.native="isCollapsed=!isCollapsed" :style="{padding: '0 24px'}" type="md-menu" size="24"></Icon>
            </Tooltip>
          </div>
          <vue-scroll>
            <Menu theme="light" width="auto" :class="menuitemClasses">
              <section v-for="(menu,idx) in leftMenu" :key="idx">
                <MenuItem :name="menu.name" :to="menu.link" v-if="!menu.children||!menu.children.length">
                  <Icon :type="menu.icon" v-if="menu.icon" />
                  {{menu.title}}
                </MenuItem>
                <Dropdown placement="right" :transfer="true" v-else-if="isCollapsed">
                  <MenuItem :name="menu.name">
                    <Icon :type="menu.icon" v-if="menu.icon"></Icon>
                    <Icon type="ios-arrow-forward" class="left-menu-arrow"></Icon>
                  </MenuItem>
                  <DropdownMenu slot="list">
                    <DropdownItem v-for="(sub,sidx) in menu.children" :key="idx+'-sub-'+sidx"><router-link :to="sub.link">{{sub.title}}</router-link></DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Submenu :name="menu.name" v-else>
                  <template slot="title">
                    <Icon :type="menu.icon" v-if="menu.icon"></Icon>
                    <span>{{menu.title}}</span>
                  </template>
                  <MenuItem :name="sub.name" :to="sub.link" v-for="(sub,sidx) in menu.children" :key="idx+'-sub-'+sidx">{{sub.title}}</MenuItem>
                </Submenu>
              </section>
            </Menu>
          </vue-scroll>
        </Sider>
        <!-- 小屏幕悬浮菜单 -->
        <div class="mobile-sidebar-overlay" v-if="isMobile && showMobileSidebar" @click="showMobileSidebar=false">
          <div class="mobile-sidebar-content" @click.stop>
            <div class="mobile-sidebar-header">
              <span>菜单</span>
              <Icon type="md-close" size="20" @click="showMobileSidebar=false" />
            </div>
            <vue-scroll>
              <Menu theme="light" width="auto">
                <section v-for="(menu,idx) in leftMenu" :key="idx">
                  <MenuItem :name="menu.name" :to="menu.link" v-if="!menu.children||!menu.children.length" @click.native="showMobileSidebar=false">
                    <Icon :type="menu.icon" v-if="menu.icon" />
                    {{menu.title}}
                  </MenuItem>
                  <Submenu :name="menu.name" v-else>
                    <template slot="title">
                      <Icon :type="menu.icon" v-if="menu.icon" />
                      <span>{{menu.title}}</span>
                    </template>
                    <MenuItem :name="sub.name" :to="sub.link" v-for="(sub,sidx) in menu.children" :key="idx+'-sub-'+sidx" @click.native="showMobileSidebar=false">{{sub.title}}</MenuItem>
                  </Submenu>
                </section>
              </Menu>
            </vue-scroll>
          </div>
        </div>
        <!-- 小屏幕悬浮按钮 -->
        <div class="sidebar-toggle-btn" v-if="isMobile" @click="showMobileSidebar=true">
          <Icon type="md-menu" size="20" />
        </div>
        <Layout :style="{padding: isMobile?'0':'0 0 0 16px'}">
          <div class="page-tags" v-if="!isMobile">
            <Tag :closable="tags.length>1" type="border"
              :color="isCurrentTag(tag) ? 'primary' : 'default'"
              v-for="(tag,idx) in tags"
              :key="idx"
              @on-close="closeTag(tag)">
              <span style="cursor: pointer" @click="switchTag(tag)">
                {{tag.meta.tagName}}
              </span>
            </Tag>
          </div>
          <Content :style="{padding: '10px 16px', minHeight: '280px', background: '#fff', overflow: 'auto'}">
            <!-- <vue-scroll> -->
            <keep-alive :include="keepAliveTags">
              <router-view @changePwd="showChangePwdModal" @bindMobile="showBindMobile" />
            </keep-alive>
            <!-- </vue-scroll> -->
          </Content>
          <div class="float-window" v-if="!isMobile">
            <router-link class="float-item apply" to="/dashboard">
              <Icon size="24" type="md-person" />
              <div class="title">我的</div>
            </router-link>
            <div class="float-item consultant" v-if="$store.getters.sysConfigs.CONSULTANT">
              <Icon size="24" type="ios-chatbubbles-outline" />
              <div class="title">咨询</div>
              <div class="consultant-box">
                <div class="consultant-item"
                  v-for="(cons,consIdx) in  $store.getters.sysConfigs.CONSULTANT"
                  :key="consIdx">
                  {{cons}}
                </div>
              </div>
              <div class="arrow-right"></div>
            </div>
            <!-- <a class="float-item help" href="/FAQ.html">
              <Icon size="24" type="md-help-circle" />
              <div class="title">帮助</div>
            </a> -->
            <a class="float-item help" v-if="$store.getters.sysConfigs.GUIDANCE_URL" target="_blank" :href="$store.getters.sysConfigs.GUIDANCE_URL">
              <Icon size="24" type="logo-youtube" />
              <div class="title">教程</div>
            </a>
          </div>
          <Footer v-if="!isMobile" />
        </Layout>
      </Layout>
    </Layout>
    <Modal v-model="changePwdModal"
      :mask="true"
      :mask-closable="!changePwdForced"
      :closable="!changePwdForced"
      @on-cancel="cancelChangePwd"
      title="修改密码">
      <Form ref="changePwdForm"
        label-position="left"
        :model="changePwdModel"
        :rules="changePwdRules"
        :label-width="120">
        <FormItem label="原始密码" prop="oldPassword">
          <Input v-model="changePwdModel.oldPassword" type="password" placeholder="输入原始密码" />
        </FormItem>
        <FormItem label="输入新密码" prop="newpassword">
          <Input v-model="changePwdModel.newpassword" type="password" placeholder="输入新密码" />
        </FormItem>
        <FormItem label="重复新密码" prop="renewpassword">
          <Input v-model="changePwdModel.renewpassword" type="password" placeholder="重复输入新密码" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitChangePwd">提交</Button>
        <Button @click="cancelChangePwd" v-if="!changePwdForced">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showBindMobileModal"
      scrollable
      :mask="true"
      :mask-closable="false"
      @on-cancel="closeBindMobile"
      title="绑定手机">
      <Form ref="bindMobileForm"
        label-position="left"
        :model="bindMobileModel"
        :label-width="120">
        <FormItem label="手机号码" prop="mobile" :rules="[{required:true,validator:validatePhone,trigger:'blur'}]">
          <Input v-model="bindMobileModel.mobile" placeholder="输入手机号" style="width:180px" />
          <Button type="primary" style="margin-left:5px" @click="sendBindSms" :disabled="bindSmsCD">{{bindSmsCD?`${bindSmsCountDown}秒后重发`:'发送验证码'}}</Button>
          <div class="text-grey small" v-if="bindSmsCD">验证码已发送至{{bindMobileModel.mobile}},请注意查收</div>
        </FormItem>
        <FormItem label="短信验证码" prop="code" :rules="[{required:true,message:'请输入短信验证码',trigger:'blur'}]">
          <Input v-model="bindMobileModel.code" style="width:100px" placeholder="短信验证码" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="bindMobile">提交</Button>
        <Button @click="closeBindMobile">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
// @ is an alias to /src
import Footer from '@/components/Footer.vue'

export default {
  name: 'HomeDefault',
  components: {
    Footer
  },
  data () {
    const validateRepassword = (rule, value, callback) => {
      if (this.changePwdModel.newpassword && value !== this.changePwdModel.newpassword) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      tags: [],
      isCollapsed: false,
      searchKeyword: '',
      searchFocused : false,
      showQuickSearchBox: false,
      showMobileSidebar: false,
      leftMenu: [],
      menuAdmin: [
        {
          name: 'users',
          icon: 'md-contacts',
          title: '用户管理',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'user-list',
              title: '用户管理',
              link: '/users/list'
            },
            {
              name: 'user-new',
              title: '新增用户',
              link: '/users/new'
            }
          ]
        },
        {
          name: 'permissions',
          icon: 'md-medal',
          title: '权限管理',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'permission-list',
              title: '基础权限设置',
              link: '/permissions/list'
            },
            {
              name: 'role-list',
              title: '角色管理',
              link: '/roles/list'
            }
          ]
        },
        {
          name: 'guarantors',
          icon: 'ios-contacts',
          title: '保证人管理',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'guarantor-new',
              title: '新增保证人',
              link: '/guarantors/new'
            },
            {
              name: 'guarantor-list',
              title: '保证人管理',
              link: '/guarantors/list'
            },
            {
              name: 'guarantor-regional-list',
              title: '区域保证人管理',
              link: '/guarantors/listregional'
            },
            {
              name: 'guarantor-industrial-list',
              title: '行业保证人管理',
              link: '/guarantors/listindustrial'
            },
            {
              name: 'template-list',
              title: '保函模板管理',
              link: '/templates/list'
            }
          ]
        },
        {
          name: 'database',
          icon: 'md-cube',
          title: '基础数据管理',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'project-list',
              title: '项目管理',
              link: '/projects/list'
            },
            {
              name: 'company-list',
              title: '企业管理',
              link: '/companies/list'
            },
            {
              name: 'expert-list',
              title: '专业技术人员管理',
              link: '/experts/list'
            }
          ]
        },
        {
          name: 'guarantees',
          icon: 'md-list-box',
          title: '保函管理',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'guarantee-list',
              title: '保函列表',
              link: '/guarantees/list'
            },
            {
              name: 'eguarantee-list',
              title: '电子保函管理',
              link: '/guarantees/list?elec=true'
            }
          ]
        },
        {
          name: 'project-registers',
          icon: 'md-book',
          title: '存储通知书',
          link: null,
          children: [
            {
              name: 'project-register-list',
              title: '通知书列表',
              // link: '/project-register/list'
              link: {name : 'project-register-list', params: {mode: 'ZhengZhouRenShe'}}
            }
          ]
        },
        {
          name: 'credit-center',
          icon: 'md-trophy',
          title: '信用中心',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'company-credit-record-list',
              title: '保证人信用记录',
              link: '/company-credit-record/list'
            },
            {
              name: 'guaranteed-bad-record-list',
              title: '投保人不良行为记录',
              link: '/guaranteed-bad-record/list'
            }
          ]
        },
        {
          name: 'guarantor-appraisal',
          icon: 'ios-create',
          title: '信用评价',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'guarantor-appraisal-question-list',
              title: '信用评价题目管理',
              link: '/guarantor-appraisal/list-question'
            },
            {
              name: 'guarantor-appraisal-section-list',
              title: '信用评价大题管理',
              link: '/guarantor-appraisal/list-section'
            },
            {
              name: 'guarantor-appraisal-paper-list',
              title: '信用评价试卷管理',
              link: '/guarantor-appraisal/list-paper'
            },
            {
              name: 'guarantor-appraisal-record-list',
              title: '信用评价记录',
              link: '/guarantor-appraisal/list-record'
            },
          ]
        },
        {
          name: 'reports',
          icon: 'ios-analytics',
          title: '报表中心',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'business-report',
              title: '业务开展情况',
              link: '/statistics/overall'
            }
          ]
        },
        {
          name: 'system',
          icon: 'md-construct',
          title: '系统设置',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'announcement-list',
              title: '公告管理',
              link: '/announcements/list'
            },
            {
              name: 'guarantor-list',
              title: '监管人管理',
              link: '/supervisors/list'
            },
            {
              name: 'admin-new',
              title: '新增后台用户',
              link: '/admins/new'
            },
            {
              name: 'admin-list',
              title: '后台用户管理',
              link: '/admins/list'
            },
            {
              name: 'industry-list',
              title: '行业领域管理',
              link: '/industries/list'
            },
            {
              name: 'city-list',
              title: '城市管理',
              link: '/cities/list'
            },
            {
              name: 'guarantee-variety-list',
              title: '保证种类管理',
              link: '/gua-types/list'
            },
            {
              name: 'kvs-list',
              title: '配置管理',
              link: '/kvs/list'
            },
          ]
        }
      ],
      menuGeneralSupervisor: [],
      menuSupervisor: [],
      menuGuarantor: [],
      menuGuarantorUnregistered: [
        {
          name: 'guarantors',
          icon: 'ios-contacts',
          title: '保证人登记',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'user-list',
              title: '我的登记信息',
              link: '/guarantors/mydetail'
            }
          ]
        }
      ],
      menuContractor: [
      {
          name: 'guarantees',
          icon: 'md-list-box',
          title: '保函管理',
          link: null, // 如果没有子菜单则应显示为链接
          children: [
            {
              name: 'guarantee-list',
              title: '保函列表',
              link: '/guarantees/list'
            },
            {
              name: 'eguarantee-list',
              title: '电子保函管理',
              link: '/guarantees/list?elec=true'
            }
          ]
        },
        {
          name: 'project-registers',
          icon: 'md-book',
          title: '存储通知书',
          link: null,
          children: [
            {
              name: 'project-register-add-by-contractor',
              title: '发起申请',
              link: '/project-register/addbycontractor'
            },
            {
              name: 'project-register-list',
              title: '通知书列表',
              // link: '/project-register/list'
              link: {name : 'project-register-list', params: {mode: 'ZhengZhouRenShe'}}
            }
          ]
        },
      ],
      guarantorUnregistered: false,
      changePwdModal: false,
      changePwdForced: false,
      changePwdModel: {
        id: null,
        oldPasswordMd5: null,
        oldPassword: null,
        passwordMd5: null,
        newpassword: null,
        renewpassword: null
      },
      changePwdRules: {
        oldPassword: [
          { required: true, message: '请输入原始密码', trigger: 'blur' }
        ],
        newpassword: [
          // { validator: this.validatePasswordStrength, trigger: 'blur' }
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: this.checkCharTypes, trigger: 'blur'},
          { validator: this.checkLength, trigger: 'blur'}
        ],
        renewpassword: [
          { required: true, message: '请重复新密码', trigger: 'blur' },
          { validator: validateRepassword, trigger: 'blur' }
        ]
      },
      supvPerms: {
        canAuditGuarantor: false,
        canPreAuditGuarantor: false,
        canBlacklistGuarantor: false,
        canClaim: false,
        canAddProjectRegister: false,
        canAuditProjectRegister: false,
        projectRegisterMode: null
      },
      showBindMobileModal: false,
      bindMobileMode: 'bind', // bind,rebind
      bindMobileModel: {
        mobile: null,
        code: null
      },
      bindSmsCD: false,
      bindSmsCountDown: 60,
      bindSmsCountDownTask: null
    }
  },
  computed: {
    keepAliveTags () {
      return this.$store.getters.keepAliveTags
    },
    menuitemClasses: function () {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    },
    isMobile () {
      return ['xs', 'sm', 'md'].indexOf(this.$store.getters.screenSize) > -1
    }
  },
  watch: {
    '$route': function (val) {
      let exists = this.tags.filter((t) => {
        return t.name === this.$route.name
      })
      if (!exists || !exists.length) {
        this.tags.push(val)
      } else {
        if (exists.path !== val.path) {
          this.$nextTick(() => {
            // this.tags.splice(this.tags.findIndex(o => o.name === this.$route.name), 1)
            // this.tags.push(val)
          })
        }
      }
      if (val.meta.keepAlive) {
        this.$nextTick(() => {
          this.$store.dispatch('setKeepAliveTag', val.name)
        })
      }
      if (val.meta.maxView) {
        this.isCollapsed = true
      }
    },
    guarantorUnregistered: function (val) {
      if (val) {
        this.leftMenu = this.menuGuarantorUnregistered
      }
    }
  },
  async mounted () {
    await this.initMyData()
    let exists = this.tags.filter((t) => {
      return t.name === this.$route.name
    })
    if (!exists || !exists.length) {
      this.tags.push(this.$route)
    }
    if (this.$route.meta.keepAlive) {
      this.$store.dispatch('setKeepAliveTag', this.$route.name)
    }
    setTimeout(() => {
      // console.log(window.themeSwitcher.getThemes(), window.themeSwitcher)
      // setTimeout(() => {
      //   window.themeSwitcher.setTheme('red').then(()=>{
      //     console.log('切换主题完成')
      //   })
      // }, 20000)
    }, 5000)
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    getMoment (dt) {
      return moment(dt)
    },
    isCurrentTag (tag) {
      return this.$route.name === tag.name
    },
    switchTag (tag) {
      let path = tag.path
      if (path) {
        this.$router.push(path)
      }
    },
    closeTag (tag) {
      if (this.tags.length > 1) {
        this.$store.dispatch('removeKeepAliveTag', tag.name)
        let idx = this.tags.indexOf(tag)
        if (idx > -1) {
          this.tags.splice(idx, 1)
        }
        if (this.tags.length) {
          if (idx === 0) {
            this.$router.push(this.tags[idx].path)
          } else {
            this.$router.push(this.tags[idx - 1].path)
          }
        } else {
          this.$router.push('/')
        }
      }
    },
    searchInputBlur () {
      if (this.searchKeyword) {
        this.searchFocused = true
      } else {
        this.searchFocused = false
      }
    },
    async initMyData () {
      return new Promise((resolve, reject) => {
        this.$Api.Auth(this).getMyDetail().then(async (data) => {
          try {
            this.$store.dispatch('setUserInfo', data)
            window.localStorage.setItem('userInfo', JSON.stringify(data))
            if (data.needUpdate) {
              let forceChangePwdOnFirstLogin = this.$store.getters.sysConfigs['FORCE_CHANGE_PWD_ON_FIRST_LOGIN'] || false
              if (forceChangePwdOnFirstLogin) {
                this.$Modal.warning({
                  title: '密码需更新',
                  content: '请先设置新密码',
                  okText: '好的',
                  onOk: () => {
                    this.showChangePwdModal(forceChangePwdOnFirstLogin)
                  }
                })
              } else {
                this.$Modal.confirm({
                  title: '密码需更新',
                  content: '请先设置新密码',
                  okText: '好的',
                  cancelText: '稍晚',
                  onOk: () => {
                    this.showChangePwdModal(forceChangePwdOnFirstLogin)
                  }
                })
              }
            }
            if ('保证人' === this.$common.userType[data.type]) {
              this.getMyGuarantorInfo()
              this.menuGuarantor = await this.$store.getters.menuGuarantor
              this.$nextTick(() => {
                if (this.$store.getters.sysConfigs['ENABLE_RECEIPT']) {
                  this.menuGuarantor.push({
                    name: 'receipts',
                    icon: 'md-cash',
                    title: '现金保证金',
                    link: null,
                    children: [
                      {
                        name: 'receipt-new',
                        title: '新增保证金',
                        link: '/receipts/new'
                      },
                      {
                        name: 'receipt-list',
                        title: '保证金管理',
                        link: '/receipts/list'
                      }
                    ]
                  })
                }
                this.leftMenu = this.menuGuarantor
                resolve()
              })
            } else if ('监管人' === this.$common.userType[data.type]) {
              await this.getMySupervisionPermission()
              this.getMySupervisorInfo()
              this.menuSupervisor = await this.$store.getters.menuSupervisor
              this.$nextTick(() => {
                if (this.supvPerms.canAddProjectRegister || this.supvPerms.canAuditProjectRegister) {
                  let exists = this.menuSupervisor.findIndex(o => o.name === 'project-registers')
                  if (exists < 0) {
                    if (this.$store.getters.sysConfigs['ENABLE_RECEIPT']) {
                      this.menuSupervisor.push({
                        name: 'receipts',
                        icon: 'md-cash',
                        title: '现金保证金',
                        link: null,
                        children: [
                          // {
                          //   name: 'receipt-new',
                          //   title: '新增保证金',
                          //   link: '/receipts/new'
                          // },
                          {
                            name: 'receipt-list',
                            title: '保证金管理',
                            link: '/receipts/list'
                          }
                        ]
                      })
                    }
                    this.menuSupervisor.push({
                      name: 'project-registers',
                      icon: 'md-book',
                      title: '存储通知书',
                      link: null,
                      children: [
                        {
                          name: 'project-register-list',
                          title: '通知书列表',
                          link: '/project-register/list'
                        }
                      ]
                    })
                  }
                }
                this.leftMenu = this.menuSupervisor
                resolve()
              })
            } else if ('总承包' === this.$common.userType[data.type]) {
              this.$nextTick(() => {
                this.leftMenu = this.menuContractor
                resolve()
              })
            } else if ('总监管人' === this.$common.userType[data.type]) {
              let businessType = window.localStorage.getItem('business-type')
              if (businessType === 'guarantee') {
                this.menuGeneralSupervisor = [
                  {
                    name: 'users',
                    icon: 'md-contacts',
                    title: '用户管理',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'user-list',
                        title: '用户管理',
                        link: '/users/list'
                      },
                    ]
                  },
                  {
                    name: 'guarantors',
                    icon: 'ios-contacts',
                    title: '保证人管理',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'guarantor-list',
                        title: '保证人管理',
                        link: '/guarantors/list'
                      },
                      {
                        name: 'guarantor-regional-list',
                        title: '区域保证人管理',
                        link: '/guarantors/listregional'
                      },
                      {
                        name: 'guarantor-industrial-list',
                        title: '行业保证人管理',
                        link: '/guarantors/listindustrial'
                      },
                      {
                        name: 'template-list',
                        title: '保函模板管理',
                        link: '/templates/list'
                      }
                    ]
                  },
                  {
                    name: 'database',
                    icon: 'md-cube',
                    title: '基础数据管理',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'project-list',
                        title: '项目管理',
                        link: '/projects/list'
                      },
                      {
                        name: 'company-list',
                        title: '企业管理',
                        link: '/companies/list'
                      },
                      {
                        name: 'expert-list',
                        title: '专业技术人员管理',
                        link: '/experts/list'
                      }
                    ]
                  },
                  {
                    name: 'guarantees',
                    icon: 'md-list-box',
                    title: '保函管理',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'guarantee-list',
                        title: '保函列表',
                        link: '/guarantees/list'
                      },
                      {
                        name: 'eguarantee-list',
                        title: '电子保函管理',
                        link: '/guarantees/list?elec=true'
                      }
                    ]
                  },
                  {
                    name: 'credit-center',
                    icon: 'md-trophy',
                    title: '信用中心',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'company-credit-record-list',
                        title: '保证人信用记录',
                        link: '/company-credit-record/list'
                      },
                      {
                        name: 'guaranteed-bad-record-list',
                        title: '投保人不良行为记录',
                        link: '/guaranteed-bad-record/list'
                      }
                    ]
                  },
                  {
                    name: 'reports',
                    icon: 'ios-analytics',
                    title: '报表中心',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'business-report',
                        title: '业务开展情况',
                        link: '/statistics/overall'
                      }
                    ]
                  },
                  {
                    name: 'system',
                    icon: 'md-construct',
                    title: '系统设置',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'announcement-list',
                        title: '公告管理',
                        link: '/announcements/list'
                      },
                      {
                        name: 'guarantor-list',
                        title: '监管人管理',
                        link: '/supervisors/list'
                      },
                    ]
                  }
                ]
              } else if (businessType === 'appraisal') {
                this.menuGeneralSupervisor = [
                  {
                    name: 'users',
                    icon: 'md-contacts',
                    title: '用户管理',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'user-list',
                        title: '用户管理',
                        link: '/users/list'
                      },
                      {
                        name: 'user-new',
                        title: '新增用户',
                        link: '/users/new'
                      }
                    ]
                  },
                  {
                    name: 'guarantor-appraisal',
                    icon: 'ios-create',
                    title: '信用评价',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'guarantor-appraisal-question-list',
                        title: '信用评价题目管理',
                        link: '/guarantor-appraisal/list-question'
                      },
                      {
                        name: 'guarantor-appraisal-section-list',
                        title: '信用评价大题管理',
                        link: '/guarantor-appraisal/list-section'
                      },
                      {
                        name: 'guarantor-appraisal-paper-list',
                        title: '信用评价试卷管理',
                        link: '/guarantor-appraisal/list-paper'
                      },
                      {
                        name: 'guarantor-appraisal-record-list',
                        title: '信用评价记录',
                        link: '/guarantor-appraisal/list-record'
                      },
                    ]
                  },
                  {
                    name: 'system',
                    icon: 'md-construct',
                    title: '系统设置',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'announcement-list',
                        title: '公告管理',
                        link: '/announcements/list'
                      },
                    ]
                  }
                ]
              } else if (businessType === 'member') {
                this.menuGeneralSupervisor = [
                  {
                    name: 'users',
                    icon: 'md-contacts',
                    title: '用户管理',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [
                      {
                        name: 'user-list',
                        title: '用户管理',
                        link: '/users/list'
                      },
                      {
                        name: 'user-new',
                        title: '新增用户',
                        link: '/users/new'
                      }
                    ]
                  },
                  {
                    name: 'guarantors',
                    icon: 'ios-contacts',
                    title: '保证人管理',
                    link: null, // 如果没有子菜单则应显示为链接
                    children: [

                      {
                        name: 'guarantor-list',
                        title: '保证人管理',
                        link: '/guarantors/list'
                      }
                    ]
                  }
                ]
              } else {
                this.menuGeneralSupervisor = await this.$store.getters.menuGeneralSupervisor
              }
              this.$nextTick(() => {
                this.leftMenu = this.menuGeneralSupervisor
                resolve()
              })
            } else if ('管理员' === this.$common.userType[data.type]) {
              this.$nextTick(() => {
                this.leftMenu = this.menuAdmin
                resolve()
              })
            }
          } catch (err) {
            reject(err)
          }
        })
      })
    },
    async submitChangePwd () {
      this.$refs.changePwdForm.validate(async (valid) => {
        if (valid) {
          this.$Spin.show()
          this.changePwdModel.oldPasswordMd5 = this.$md5(this.changePwdModel.oldPassword)
          this.changePwdModel.passwordMd5 = this.$md5(this.changePwdModel.newpassword)
          await this.$Api.Auth(this).updateUserPassword(this.changePwdModel)
          .then(() => {
            this.$Message.success('更新密码成功!')
            this.loading = false
            this.$Spin.hide()
            this.cancelChangePwd()
            this.initMyData()
          })
          .catch(err => {
            this.loading = false
            this.$Spin.hide()
            this.$Notice.error({
              title: '更新密码失败!',
              desc: err.message
            })
          })
        }
      })
    },
    showChangePwdModal (force = false) {
      this.changePwdForced = force
      this.changePwdModel = {
        id: this.$store.getters.userInfo.id,
        oldPasswordMd5: null,
        oldPassword: null,
        passwordMd5: null,
        newpassword: null,
        renewpassword: null
      }
      this.changePwdModal = true
    },
    cancelChangePwd () {
      this.changePwdForced = false
      this.changePwdModal = false
      this.changePwdModel = {
        id: this.$store.getters.userInfo.id,
        oldPasswordMd5: null,
        oldPassword: null,
        passwordMd5: null,
        newpassword: null,
        renewpassword: null
      }
    },
    async getMyGuarantorInfo () {
      this.$Spin.show()
      await this.$Api.Guarantor.getMyGuarantorDetail()
      .then((payload) => {
        if (payload.status !== 3) {
          this.guarantorUnregistered = true
        }
        this.loading = false
        this.$Spin.hide()
        this.$store.dispatch('setGuarantorInfo', payload)
        window.localStorage.setItem('guarantor-info', JSON.stringify(payload))
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '获取保证人信息!',
          desc: err.message
        })
        if (err.message.indexOf('该用户未绑定承保人') > -1) {
          this.guarantorUnregistered = true
          this.$Modal.warning({
            title: '访问受限',
            content: '请先完成保证人登记',
            onOk: () => {
              this.$router.push({path: '/guarantors/mydetail'})
            },
            onCancel: () => {
              this.$router.push({path: '/guarantors/mydetail'})
            }
          })
        }
      })
    },
    async getMySupervisionPermission () {
      await this.$Api.Supervisor.getMySupervisorPermissions()
      .then((res) => {
        // console.log(res)
        this.supvPerms = res
        return Promise.resolve()
      })
      .catch((err) => {
        this.supvPerms = {
          canAuditGuarantor: false,
          canPreAuditGuarantor: false,
          canBlacklistGuarantor: false,
          canClaim: false,
          canAddProjectRegister: false,
          canAuditProjectRegister: false,
          projectRegisterMode: null
        }
        return Promise.reject(err)
      })
    },
    async getMySupervisorInfo () {
      this.$Spin.show()
      await this.$Api.Supervisor.getMySupervisorDetail()
      .then((payload) => {
        this.loading = false
        this.$Spin.hide()
        this.$store.dispatch('setSupervisorInfo', payload)
        window.localStorage.setItem('supervisor-info', JSON.stringify(payload))
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '获取监管人信息!',
          desc: err.message
        })
        if (err.message.indexOf('该用户未绑定监管人') > -1) {
          this.logOut()
        }
      })
    },
    async logOut () {
      this.$Spin.show()
      await this.$Api.Auth(this).logout().then(() => {
        this.$Message.success('登出成功!')
        this.$Spin.hide()
        this.$store.dispatch('logout')
        this.$router.push({path: '/welcome'})
      }).catch(err => {
        this.$Spin.hide()
        this.$Message.error('登出失败!' + err.message)
        this.$store.dispatch('logout')
        this.$router.push({path: '/welcome'})
      })
    },
    async searchFuzzy () {
      if (this.searchKeyword) {
        this.$router.push({
          path: '/guarantees/list?keyword=' + this.searchKeyword
        })
      }
    },
    checkCharTypes (rule, value, callback) {
      if (rule) {
        let charTypes = this.$common.checkStrCharacterTypes(value)
        console.log(charTypes)
        if (charTypes.count < 3) {
          callback(new Error('密码强度不足,请增加大小写、数字、符号'))
        } else {
          if (callback) {
            callback()
          }
        }
      }
    },
    checkLength (rule, value, callback) {
      if (rule) {
        let length = value.length
        if (length < 8) {
          callback(new Error(`密码长度不足8位`))
        } else {
          if (callback) {
            callback()
          }
        }
      }
    },
    showBindMobile (rebind = false) {
      this.bindMobileMode = rebind ? 'rebind' : 'bind'
      if (this.bindSmsCountDownTask) {
        clearInterval(this.bindSmsCountDownTask)
      }
      this.bindMobileModel = {
        mobile: null,
        code: null
      }
      this.bindSmsCD = false
      this.bindSmsCountDown = 60
      this.showBindMobileModal = true
    },
    closeBindMobile () {
      if (this.bindSmsCountDownTask) {
        clearInterval(this.bindSmsCountDownTask)
      }
      this.bindMobileModel = {
        mobile: null,
        code: null
      }
      this.showBindMobileModal = false
    },
    validatePhone (rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback('手机号格式不正确')
      } else {
        callback()
      }
    },
    sendBindSms () {
      if (!this.bindMobileModel || !this.bindMobileModel.mobile) {
        this.$Message.error('请填写手机号码')
        return false
      }
      this.$Api.Auth(this).sendBindSmsCode(this.bindMobileModel.mobile).then(() => {
        this.$Message.success('短信验证码发送成功')
        if (this.bindSmsCountDownTask) {
          clearInterval(this.bindSmsCountDownTask)
        }
        this.bindSmsCD = true
        this.bindSmsCountDown = 60
        this.bindSmsCountDownTask = setInterval(() => {
          if (this.bindSmsCountDown >= 1) {
            this.bindSmsCountDown--
          } else {
            this.bindSmsCountDown = 60
            this.bindSmsCD = false
            clearInterval(this.bindSmsCountDownTask)
          }
        }, 1000)
      }).catch(err => {
        this.$Message.error('短信验证码发送失败!' + err.message)
      })
    },
    procSmsVerified (res) {
      if (!res.data.success) {
        let errorMsg = res.data.message
        this.$Notice.error({
          title: '绑定失败!',
          desc: errorMsg
        })
      } else {
        this.$Message.success('绑定成功!')
        this.$store.dispatch('setUserMobile', this.bindMobileModel.mobile)
        this.$Spin.hide()
        this.$nextTick(() => {
          this.closeBindMobile()
        })
      }
    },
    async bindMobile () {
      this.$Spin.show()
      if (this.bindMobileMode === 'rebind') {
        await this.$Api.Auth(this).changeMobile(this.bindMobileModel.mobile, this.bindMobileModel.code).then(() => {
          this.$Message.success('绑定成功!')
          this.$store.dispatch('setUserMobile', this.bindMobileModel.mobile)
          this.$Spin.hide()
          this.$nextTick(() => {
            this.closeBindMobile()
          })
        }).catch(err => {
          console.log(err)
          this.$Spin.hide()
          if (err.message === '请提供验证码') {
            this.$store.dispatch('setSmsVerifierCallbackFn', this.procSmsVerified)
            this.$store.dispatch('setSmsVerifierCallbackArgs', null)
          } else {
            this.$Notice.error({
              title: '绑定失败!',
              desc: err.message
            })
          }
        })
      } else if (this.bindMobileMode === 'bind') {
        await this.$Api.Auth(this).bindMobile(this.bindMobileModel.mobile, this.bindMobileModel.code).then(() => {
          this.$Message.success('绑定成功!')
          this.$store.dispatch('setUserMobile', this.bindMobileModel.mobile)
          this.$Spin.hide()
          this.$nextTick(() => {
            this.closeBindMobile()
          })
        }).catch(err => {
          this.$Spin.hide()
          this.$Notice.error({
            title: '绑定失败!',
            desc: err.message
          })
        })
      }
    },
  }
}
</script>

<style lang="less">
.home {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100vh;
  width: 100%;
  .layout {
    height: 100%;
  }
}
.header {
  background: linear-gradient(30deg, @primaryColor, @secondaryColor) !important;
  padding: 0 !important;
}
.top-bar {
  background: transparent !important;
  padding: 0 !important;
}
.top-bar-search {
  display: inline-block !important;
  width: 100px !important;
  margin-right: 20px !important;
  transition: all linear .3s !important;
  &.expand {
    width: 300px !important;
  }
}
.quick-search-box {
  position: absolute;
  right: -65px;
  top: 65px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-shadow: 0 0 5px #efefef;
  padding: 16px 16px 8px 16px;
  .quit-icon {
    position: absolute;
    right: 3px;
    top: 3px;
  }
  .top-bar-search {
    margin-right: 0 !important;
  }
}
.layout-logo {
  height: 50px;
  // background: #5b6270;
  color: #fefefe;
  text-align: center;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 5px;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  .site-name-area {
    line-height: initial;
    text-align: left;
  }
}
.layout-nav{
  margin: 0 auto;
  margin-right: 20px;
  display: inline-block;
}
.user-info-area {
  display: flex;
  flex-direction: row;
  padding: 16px 5px;
  align-items: flex-start;
  .user-avatar {
    width: 60px !important;
    height: auto;
    overflow: hidden;
    display: inline-block;
    position: relative;
    img {
      width: 60px !important;
    }
  }
  .user-info {
    margin-left: 5px;
    ul {
      list-style: none;
      // text-align: center;
    }
  }
}
.page-tags {
  margin: 8px 16px 8px 0;
  // padding: 5px;
  // background: #fff;
}

.layout-con{
  height: 100%;
  width: 100%;
}
.left-menu {
  .menu-item span{
    display: inline-block;
    overflow: hidden;
    width: 90px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width .2s ease .2s;
  }
  .menu-item i{
    // transform: translateX(0px);
    transition: font-size .2s ease, transform .2s ease;
    vertical-align: middle;
    font-size: 16px;
  }
  .left-menu-trigger {
    position: absolute;
    bottom: 24px;
    right: 0;
    cursor: pointer;
  }
  .collapsed-menu span{
    width: 0px;
    transition: width .2s ease;
  }
  .collapsed-menu i{
    transform: translateX(5px);
    transition: font-size .2s ease .2s, transform .2s ease .2s;
    vertical-align: middle;
    font-size: 22px;
  }
  .ivu-menu-item {
    .left-menu-arrow {
      position: absolute;
      color: #ccc;
      opacity: 0;
      transition: all ease-in-out .3s;
    }
    &:hover {
      background: #f2f2f2;
      .left-menu-arrow {
        opacity: 1;
      }
    }
  }
}
.ivu-menu-vertical.ivu-menu-light:after {
  display: none !important;
}
.float-window {
  position: fixed;
  right: 24px;
  width: 60px;
  padding: 0 10px;
  background: rgba(0, 0, 0, 0.5);
  bottom: 180px;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  .float-item {
    display: block;
    cursor: pointer;
    padding: 10px 5px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ccc;
    &:not(:last-child) {
      border-bottom: 1px dotted #ccc;
    }
    &:hover {
      color: #fff;
    }
    .title {
      line-height: 14px;
    }
    &.consultant {
      position: relative;
      cursor: default;
      .arrow-right {
        opacity: 0;
        position: absolute;
        transition: opacity .2s linear;
        width:0;
        height:0;
        left: -15px;
        border-top:5px solid transparent;
        border-bottom:5px solid transparent;
        border-left:5px solid rgba(0, 0, 0, 0.5);
      }
      .consultant-box {
        display: none;
        opacity: 0;
        position: absolute;
        transition: opacity .2s linear;
        width: 180px;
        background: rgba(0, 0, 0, 0.5);
        left: -195px;
        z-index: 9999;
        padding: 10px;
      }
      &:hover {
        .consultant-box {
          opacity: 1;
          display: block;
        }
        .arrow-right {
          opacity: 1;
        }
      }
    }
  }
}
.sidebar-toggle-btn {
  position: fixed;
  left: 16px;
  bottom: 24px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
}
.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  .mobile-sidebar-content {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 280px;
    background: #fff;
    display: flex;
    flex-direction: column;
    .mobile-sidebar-header {
      padding: 16px;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
    }
  }
}
</style>
